<template>
<div class="viewer-footer">
    <SubmissionStatus
        :status="status"
        :lastSubmissionDate="lastSubmissionDate"/>
    <ReplyForm v-if="isReplyingToSuggestion"/>
    <SuggestionForm
        v-else-if="isIdentityLinkedUser"
        :postCooldownMinutes="channel.postCooldownMinutes"
        :lastSuggestionDate="lastSuggestionDate"
        :disabled="!isAllowedToSuggest"
        @status="onSubmissionStatus"/>
    <GrantIdentityHelper v-else />
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import ReplyForm from './ReplyForm'
import SuggestionForm from './SuggestionForm'
import SubmissionStatus from './SubmissionStatus'
import GrantIdentityHelper from './GrantIdentityHelper'

export default {
    name: 'ViewerFooter',
    data: () => ({
        status: null,
        lastSubmissionDate: null,
    }),
    computed: {
        ...mapState(['user', 'channel']),
        ...mapGetters([
            'isIdentityLinkedUser',
            'isAllowedToSuggest',
            'lastSuggestionDate',
            'isReplyingToSuggestion',
        ]),
    },
    methods: {
        onSubmissionStatus (status) {
            this.status = status
            this.lastSubmissionDate = new Date()
        },
    },
    components: {
        ReplyForm,
        SuggestionForm,
        SubmissionStatus,
        GrantIdentityHelper,
    }
}
</script>

<style lang="scss" scoped>
.viewer-footer {
    @include flex-center-children;
    position: relative;
    min-height: $sbox-panel-footer-height;
    background-color: $offwhite;
    font-size: 0.8rem;
    z-index: $sbox-panel-footer-z-index;
    color: #333;
    > * {
        color: #333;
        background-color: $offwhite;
    }
}
</style>
